module.exports = __webpack_public_path__ + "media/images/icon-document-ebf175e8c1da60e072f3979abdda1298.svg";